exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".centered-dialog[data-v-03a57da9],.v-dialog.centered-dialog[data-v-03a57da9]{background:#111213ad;box-shadow:none;border-radius:6px;width:auto;color:#242121}.container[data-v-03a57da9]{margin-bottom:0!important}h1[data-v-03a57da9]{color:#fff}", ""]);

// exports
